import { Map, OrderedMap, fromJS, Set } from 'immutable';

// Constants
import CalendarMeetingsConstants from 'Shared/constants/CalendarMeetings.constants';

const initialState = Map({
  [CalendarMeetingsConstants.State.CALENDAR_MEETINGS_BY_ID]: OrderedMap(),
  [CalendarMeetingsConstants.State.CALENDAR_MEETINGS_IDS_BY_DAY]: OrderedMap(),
});

export const CalendarMeetingssReducer = (state = initialState, action) => {
  switch (action.type) {
    case CalendarMeetingsConstants.Actions.FETCH_CALENDAR_MEETINGS_SUCCESS:
      return state
        .updateIn([CalendarMeetingsConstants.State.CALENDAR_MEETINGS_BY_ID], (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.response.calendarMeeting).map(item => [
                item.id,
                Map(fromJS({ ...item.attributes, id: item.id })),
              ])
            )
          )
        )
        .updateIn(
          [CalendarMeetingsConstants.State.CALENDAR_MEETINGS_IDS_BY_DAY, action.payload.day],
          (existing = Set()) =>
            existing.merge(Object.values(action.payload.response.calendarMeeting).map(item => item.id))
        );
    default:
      return state;
  }
};
